const oauthEN = {
    consent: {
        title: "{{clientName}} wants to access your {{schoolName}} calendar",
        subtitle: "Signed in as {{userFullName}}. Review what {{clientName}} will be able to do.",
        // Keys are DOT-FREE on purpose: i18next's default keySeparator is "." so a dotted key like
        // "calendar.read" would be mis-parsed as a nested path and never resolve. C-2 maps the AS
        // scope id ("calendar.read" etc.) to these keys.
        scopes: {
            calendarRead: "See your calendar and availability",
            calendarWrite: "Create and change events, and manage invitations",
            calendarDelete: "Delete events"
        },
        delegationNote: "This app may act on behalf of other users you manage.",
        allow: "Allow",
        deny: "Deny",
        footer: "You can revoke access at any time.",
        redirecting: "Redirecting you back to {{clientName}}…",
        errors: {
            invalidRequest: "Invalid request",
            expired: "This authorization request has expired. Return to the app and try again.",
            decisionError: "Something went wrong while submitting your decision. Please try again."
        }
    }
}

export default oauthEN
